var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 714,
    height: 504,
    viewBox: "0 0 714 504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M709.49 147C709.49 341.675 551.675 499.49 357 499.49C338.142 499.49 319.63 498.01 301.573 495.158L299.16 499.338C317.986 502.405 337.307 504 357 504C554.166 504 714 344.166 714 147C714 -50.1657 554.166 -210 357 -210C159.834 -210 0 -50.1657 0 147C0 317.167 119.058 459.527 278.419 495.324L280.784 491.229C122.748 456.395 4.50947 315.506 4.50947 147C4.50947 -47.6751 162.325 -205.491 357 -205.491C551.675 -205.491 709.49 -47.6751 709.49 147Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCircle);
export default __webpack_public_path__ + "static/media/top_circle.34f624c4db0f408e4d27e79ca38576a9.svg";
export { ForwardRef as ReactComponent };